// extracted by mini-css-extract-plugin
module.exports = {"carousel":"CarouselSelectedImageCategory_carousel__2Xl0z","carousel__image":"CarouselSelectedImageCategory_carousel__image__2sND-"};